import { FullFormAction } from "../../../Core/Store/FullFormAction";
import { AttachInfo } from "../../../../../../Common/CandyApiClient/Types/Attachments/Attacments";
import { ModelActionType } from "../../../Core/ModelStoring/Store/modelActions";
import { AttachmentInfoPath } from "../../../../../../Common/PathConstants";
import { FullFormState } from "../../../Core/Store/FullFormState";
import { getIn } from "../../../../Helpers/ReduxStateHelpers";

import { AttachmentsActionType } from "./AttachmentsActions";

export interface AttachmentState {
    allIds: string[];
    byId: { [id: string]: undefined | AttachInfo };
}

export const defaultAttachmentsState = { allIds: [], byId: {} };

export function attachmentsReducer(
    state: AttachmentState = defaultAttachmentsState,
    fullState: FullFormState,
    action: FullFormAction
): AttachmentState {
    switch (action.type) {
        case AttachmentsActionType.LoadInitialAttachments: {
            return action.payload;
        }
        case AttachmentsActionType.AddAttachments: {
            const newUniqIds = action.payload.filter(({ id }) => !state.allIds.includes(id)).map(({ id }) => id);
            const nextState = {
                allIds: [...state.allIds, ...newUniqIds],
                byId: { ...state.byId },
            };

            action.payload.forEach((attachment: AttachInfo) => {
                nextState.byId[attachment.id] = attachment;
            });

            return nextState;
        }
        case AttachmentsActionType.RemoveAttachment: {
            const { [action.payload.id]: removedAttachment, ...restAttachments } = state.byId;

            return {
                allIds: state.allIds.filter(id => removedAttachment == undefined || id !== removedAttachment.id),
                byId: restAttachments,
            };
        }
        case AttachmentsActionType.UpdateAttachment: {
            const { id, attachment } = action.payload;
            const nextState = {
                allIds: state.allIds,
                byId: { ...state.byId, [id]: attachment },
            };

            if (!state.byId[id]) {
                nextState.allIds = [...state.allIds, id];
            }

            return nextState;
        }
        case AttachmentsActionType.SetAttachmentProgress: {
            const { id, progress } = action.payload;

            const attachInfo = state.byId[id];
            if (attachInfo && Number(progress) > Number(attachInfo.meta.progress)) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        [id]: {
                            ...attachInfo,
                            meta: {
                                ...attachInfo.meta,
                                progress: progress,
                            },
                        },
                    },
                };
            }
            return state;
        }
        case ModelActionType.SetValues: {
            const { deleted } = action.payload;

            if (deleted?.length > 0) {
                const newState = {
                    allIds: [...state.allIds],
                    byId: {
                        ...state.byId,
                    },
                };
                for (const deletedPath of deleted) {
                    if (deletedPath.endsWith(AttachmentInfoPath)) {
                        const deletedAttachmentId = getIn(fullState, [
                            "viewModel",
                            ...deletedPath.getPathPartsAsArray(),
                            ".",
                            "value",
                        ]);
                        newState.allIds = newState.allIds.filter(it => it !== deletedAttachmentId);
                        delete newState.byId[deletedAttachmentId];
                    }
                }

                return newState;
            }

            return state;
        }
        default:
            return state;
    }
}
